import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const faqs = [
  {
    q: "Este e-book substitui acompanhamento profissional?",
    a: "Não. O material é educativo e não substitui avaliação, diagnóstico, tratamento ou orientação individualizada de profissionais qualificados da saúde, da educação ou do direito.",
  },
  {
    q: "Autismo tem cura?",
    a: "O autismo é uma condição do neurodesenvolvimento — o foco não é “cura”, e sim desenvolvimento, autonomia e qualidade de vida, com os apoios adequados para cada pessoa.",
  },
  {
    q: "Toda pessoa autista é não verbal?",
    a: "Não. A comunicação varia muito: pode ser verbal, gestual, escrita, visual ou por meio de comunicação aumentativa e alternativa. Ausência de fala não significa ausência de compreensão.",
  },
  {
    q: "Para quem é este material?",
    a: "Pais, familiares, cuidadores, educadores e todas as pessoas que desejam começar a compreender melhor o TEA e oferecer um apoio mais consciente.",
  },
  {
    q: "Posso ler pelo celular?",
    a: "Sim. O e-book é disponibilizado em PDF e pode ser lido em celular, tablet ou computador, sempre que você precisar consultar.",
  },
  {
    q: "Como recebo o e-book após a compra?",
    a: "Após a confirmação do pagamento na plataforma, você recebe o acesso ao arquivo digital imediatamente, no e-mail informado na compra.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="mx-auto max-w-4xl px-6 py-24 md:px-12 md:py-32">
      <Reveal className="mb-12">
        <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.22em] text-flame">
          Perguntas frequentes
        </p>
        <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
          Dúvidas comuns, respostas claras.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="border-b border-navy/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-6 text-left font-display text-lg font-semibold text-navy hover:no-underline md:text-xl">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-ink">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
